<template>
  <div class="relative flex w-full items-center">
    <!-- Currency icon inset on the left -->
    <div class="absolute left-3 flex items-center">
      <span class="text-sm font-medium text-muted-foreground">
        {{ CURRENCY_CODE_TO_ICON[currency] }}
      </span>
    </div>

    <!-- Main input -->
    <input
      :id="settingId"
      v-model="modelValue"
      type="number"
      :autofocus="autofocus"
      :required="required"
      class="design-system-input block w-full rounded-lg !pl-8 text-sm leading-4"
    />

    <!-- Currency code inset on the right -->
    <div class="absolute right-3 flex items-center">
      <span class="text-sm font-medium uppercase text-muted-foreground">
        {{ currency }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import SUPPORTED_CURRENCIES from "@/autogen/supported_currencies.json";
import { useSettingControl } from "@/components/Setting/context";

const props = defineProps<{
  modelValue?: number;
  currency: (typeof SUPPORTED_CURRENCIES)[number]["code"];
  autofocus?: boolean;
  required?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [next: number];
}>();

const CURRENCY_CODE_TO_ICON: Record<
  (typeof SUPPORTED_CURRENCIES)[number]["code"],
  string
> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CAD: "$",
  AUD: "$",
  CHF: "Fr",
  CNY: "¥",
  HKD: "$",
  INR: "₹",
  MXN: "$",
};

const modelValue = computed({
  get(): number | undefined {
    return props.modelValue;
  },
  set(next: number | "") {
    if (next === "") {
      // @ts-expect-error
      emit("update:modelValue", null);
    } else {
      emit("update:modelValue", next);
    }
  },
});

const setting = useSettingControl();
const settingId = setting?.register();
</script>
